import api from './api';

/**
 * @param {Object} options
 * @param {string} [options.statusFilter]
 * @param {string} [options.createdFrom]
 * @param {string} [options.createdTo]
 * @param {string} [options.redeemedFrom]
 * @param {string} [options.redeemedTo]
 * @param {string} [options.description]
 * @param {string[]} tokensToUpdate
 * @param {'NOT_REDEEMED' | 'REDEEMED' | 'DISABLED'} status
 * @param {boolean} [useChinaUrl]
 * @returns {Promise<{
 *  number_of_tokens_updated: 10,
 *  success: boolean
 *  description: string
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tokens-putToken
 */
export default async function updateTokens (options, tokensToUpdate,level_id, status, useChinaUrl = false) {
    const { data } = await api.put(`levels/${level_id}/tokens`, {
        token_ids: tokensToUpdate,
        status,
        ...options
    }, { useChinaUrl });

    return data;
}